<template>
    <chip label="Vue.js" removable></chip>
</template>

<script>
    /**
     * @example removable chip
     * @for chip
     * @description
     */
    module.exports = {
        components: {
            'chip': require('material-ui-vue/components/chips/chip.vue')
        }
    };
</script>


/** WEBPACK FOOTER **
 ** removable-chip.vue?0ed3cea1
 **/